import AbstractAsyncTablePage from '../abstract-async-table-page';
import WebReturnsSidebar from '../../components/web-returns/web-returns-sidebar';
import SearchForm from '../../model/search-form';
import Table from '../../components/shared/table';
import SalesOrderData from '../../model/sales-order-data';
import HTMLTemplateHelper from '../../helpers/html-template-helper';
import MessageHelper from '../../helpers/message-helper';
import ReturnsNotification from '../../components/common/returns-notification';

export default class WebReturnsAutopartsBuyback extends AbstractAsyncTablePage {
  protected readonly searchForm: SearchForm;
  protected readonly table: Table;
  protected tableColumnDefinitions: DataTables.ColumnDefsSettings[] = []; // stub

  constructor(private readonly body: JQuery) {
    super();
    this.searchForm = new WebReturnsSidebar(this.body.find('.js-searchForm') as JQuery<HTMLFormElement>);
    const tableElement = body.find('.js-table');
    this.table = new Table(tableElement, WebReturnsAutopartsBuyback.getTableColumnDefinitions(tableElement.hasClass('-autopart')));

    ReturnsNotification.initAll();
    this.bindAsyncData();
  }

  private static getTableColumnDefinitions(isAutopartPage: boolean): DataTables.ColumnDefsSettings[] {
    const urlPart = isAutopartPage ? 'autopart' : 'buyback';

    return [
      { targets: 0, data: (data: SalesOrderData): string => `<a href="${window.ACC.config.encodedContextPath}/webreturns/autopart/details/${data.orderId}">${data.orderId}</a>` }, // eslint-disable-line max-len
      { targets: 1, data: 'externalId' },
      {
        targets: 2,
        data: ({ status, statusCode }: SalesOrderData): string => {
          if (!isAutopartPage) {
            return status;
          }
          return `<p class="status-badge ${statusCode === '001' ? '-active' : ''}">${status}</p>`;
        },
      },
      {
        targets: 3,
        data: (data: SalesOrderData, type: string): string | number => {
          if (type === 'sort') {
            return data.voucherDate;
          }
          return data.orderDate;
        },
      },
      {
        targets: 4,
        className: 'h-input',
        data: (data: SalesOrderData): string | null => (data.fileDownloadJwt !== '' ? HTMLTemplateHelper.createLinkButton({
          buttonClass: '-clear -compact',
          href: `${window.ACC.config.encodedContextPath}/webreturns/${urlPart}/print?token=${data.fileDownloadJwt}`,
          text: MessageHelper.getMessage('common.print'),
          textClass: 'sr-only',
          icon: 'fas fa-file-download',
        }).outerHTML : null),
      },
    ];
  }
}
